import { cn } from "@/lib/utils";

/** A friendly water droplet. `empty` renders a dashed target outline. */
export function WaterDrop({ className, empty = false }) {
  if (empty) {
    return (
      <svg viewBox="0 0 40 52" className={className} aria-hidden focusable="false">
        <path
          d="M20 3 C20 3 5 26 5 35 a15 15 0 0 0 30 0 C35 26 20 3 20 3 Z"
          fill="none"
          stroke="#9FC8EA"
          strokeWidth="3"
          strokeDasharray="4 5"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 40 52" className={cn(className)} aria-hidden focusable="false">
      <defs>
        <radialGradient id="dropBody" cx="38%" cy="32%" r="75%">
          <stop offset="0%" stopColor="#A9D6FF" />
          <stop offset="55%" stopColor="#5BA7F0" />
          <stop offset="100%" stopColor="#3B82D6" />
        </radialGradient>
      </defs>
      <path d="M20 3 C20 3 5 26 5 35 a15 15 0 0 0 30 0 C35 26 20 3 20 3 Z" fill="url(#dropBody)" />
      <ellipse cx="14" cy="33" rx="4" ry="7" fill="#FFFFFF" opacity="0.45" />
    </svg>
  );
}

export default WaterDrop;
